module.exports = __webpack_public_path__ + "img/sucker.e165598c.png";